// src/constants/routes.js
import {
  FaShoppingCart, FaUsersCog, FaUsers, FaCogs, FaUser,
  FaClipboardList, FaUserTag,
  FaTachometerAlt, FaMapMarkedAlt, FaRegListAlt,
  FaCartPlus, FaUserShield,
  FaTruck, FaRoute, FaMapMarkerAlt, FaBox, FaFileInvoice, FaChartLine, FaShieldAlt, FaBoxes, FaWarehouse, FaFileInvoiceDollar, FaReceipt, FaFileImport,
  FaIndustry, FaProjectDiagram, FaHammer, FaCog, FaCalendarAlt, FaTasks, FaChartBar, FaGlobe,
  FaHandshake, FaListUl, FaCalendarCheck, FaServer, FaTag, FaMobileAlt, FaClipboard, FaRobot,
  FaUniversity, FaMoneyBillWave, FaBalanceScale, FaCalculator, FaBook, FaSitemap, FaBuilding, FaUndo, FaExchangeAlt,
  FaUserTie, FaPoundSign, FaClock, FaBullseye, FaPercentage, FaExclamationTriangle,
  FaFileContract, FaImage, FaFilePdf, FaLayerGroup, FaEnvelope, FaQuestionCircle, FaBell, FaBarcode, FaSpider, FaDownload,
  FaRegNewspaper, FaEnvelopeOpenText, FaPhoneAlt, FaClipboardCheck
} from 'react-icons/fa';

// Complete route definitions for admin purposes only
// This should only be used in admin components that need to know about all possible routes
export const ALL_POSSIBLE_ROUTES = [
  { path: "/dashboard", icon: FaTachometerAlt, text: "Dashboard" },
  { path: "/", icon: FaShoppingCart, text: "Product Catalog" },
  { path: "/products/admin", icon: FaBoxes, text: "Products Admin" },
  { path: "/barcodes", icon: FaBarcode, text: "Barcodes" },
  { path: "/prices", icon: FaTag, text: "Price Management" },
  { path: "/discounts", icon: FaPercentage, text: "Discounts" },
  { path: "/banners", icon: FaImage, text: "Banners" },
  { path: "/cart", icon: FaShoppingCart, text: "Shopping Cart" },
  { path: "/checkout", icon: FaCartPlus, text: "Checkout" },
  { path: "/orders", icon: FaRegListAlt, text: "Orders" },
  { path: "/carts-management", icon: FaShoppingCart, text: "Carts Management" },
  { path: "/invoices", icon: FaFileInvoice, text: "Invoices" },
  { path: "/credit-notes", icon: FaUndo, text: "Credit Notes" },
  { path: "/map", icon: FaMapMarkedAlt, text: "Map" },
  { path: "/customers", icon: FaUsers, text: "Customers" },
  { path: "/users", icon: FaUsersCog, text: "User Management" },
  { path: "/profile", icon: FaUser, text: "My Account" },
  { path: "/settings", icon: FaCogs, text: "System Settings" },
  { path: "/system-logs", icon: FaClipboardList, text: "System Logs" },
  { path: "/permissions-dashboard", icon: FaChartLine, text: "Permissions Dashboard" },
  { path: "/permission-control", icon: FaShieldAlt, text: "Permission Control" },
  { path: "/header-config", icon: FaLayerGroup, text: "Header Configuration" },
  { path: "/sidebar-config", icon: FaLayerGroup, text: "Sidebar Configuration" },
  { path: "/customer-manager-assignments", icon: FaCartPlus, text: "Shop Assignment" },
  { path: "/sales-assignments", icon: FaUserTag, text: "Sales Assignments" },
  { path: "/customer-permissions", icon: FaUserShield, text: "Customer Permissions" },
  { path: "/customer-assignments", icon: FaUsersCog, text: "Customer Assignments" },
  { path: "/fulfillment", icon: FaRoute, text: "Orders Fulfillment" },
  { path: "/logistics", icon: FaTruck, text: "Logistics" },
  { path: "/logistics/routes", icon: FaRoute, text: "Routes" },
  { path: "/logistics/drivers", icon: FaUsersCog, text: "Drivers" },
  { path: "/logistics/tracking", icon: FaMapMarkerAlt, text: "Live Tracking" },
  { path: "/logistics/deliveries", icon: FaBox, text: "Deliveries" },
  { path: "/logistics/vehicles", icon: FaTruck, text: "Vehicles" },
  { path: "/logistics/route-planner", icon: FaRoute, text: "Route Planner" },
  { path: "/logistics/locations", icon: FaMapMarkerAlt, text: "Location Management" },
  { path: "/logistics/delivery-zones", icon: FaGlobe, text: "Delivery Zones" },
  { path: "/logistics/zone-neighbors", icon: FaRoute, text: "Zone Neighbors" },
  { path: "/warehouses", icon: FaWarehouse, text: "Warehouses" },
  { path: "/purchase-order", icon: FaFileInvoiceDollar, text: "Purchase Orders" },
  { path: "/purchase-planner", icon: FaCalculator, text: "Purchase Planner" },
  { path: "/suppliers", icon: FaTruck, text: "Suppliers" },
  { path: "/purchase-invoices", icon: FaFileImport, text: "Purchase Invoices" },
  { path: "/debit-notes", icon: FaExchangeAlt, text: "Debit Notes" },
  { path: "/website-scraper", icon: FaSpider, text: "Website Scraper" },
  { path: "/scraped-products", icon: FaDownload, text: "Suppliers Products" },
  { path: "/receipt", icon: FaReceipt, text: "Receipt" },
  { path: "/picking", icon: FaClipboardList, text: "Picking" },
  { path: "/packing", icon: FaBox, text: "Packing" },
  { path: "/warehousing/inventory", icon: FaBoxes, text: "Inventory Management" },
  { path: "/warehousing/stocktake", icon: FaClipboardCheck, text: "Stocktake" },
  { path: "/warehousing/cycle-counts", icon: FaClipboardCheck, text: "Cycle Counts" },
  { path: "/warehousing/transfers", icon: FaTruck, text: "Warehouse Transfers" },
  { path: "/warehousing/stock-adjustments", icon: FaClipboardCheck, text: "Stock Adjustments" },
  { path: "/warehousing/batches", icon: FaBoxes, text: "Batches" },
  { path: "/production/dashboard", icon: FaIndustry, text: "Production Dashboard" },
  { path: "/production/planner", icon: FaCalculator, text: "Production Planner" },
  { path: "/production/weekly-plan", icon: FaCalendarAlt, text: "Weekly Production Plan" },
  { path: "/production/bom", icon: FaProjectDiagram, text: "BOM Management" },
  { path: "/production/orders", icon: FaHammer, text: "Production Orders" },
  { path: "/production/workcentres", icon: FaCog, text: "Work Centres" },
  { path: "/production/planning", icon: FaCalendarAlt, text: "Production Planning" },
  { path: "/production/wip-v2", icon: FaTasks, text: "WIP Tracking V2" },
  { path: "/production/station", icon: FaHammer, text: "Operator Station" },
  { path: "/production/workstation", icon: FaHammer, text: "Workstation" },
  { path: "/production/releases", icon: FaFileInvoice, text: "Production Releases" },
  { path: "/production/qr-scanner", icon: FaShieldAlt, text: "QR Scanner" },
  { path: "/production/reports", icon: FaChartBar, text: "Production Reports" },
  { path: "/production/operations", icon: FaCog, text: "Operations Management" },
  { path: "/production/skills", icon: FaUserTag, text: "Skills" },
  { path: "/cms/pages", icon: FaGlobe, text: "Pages" },
  { path: "/cms/posts", icon: FaRegNewspaper, text: "Posts" },
  { path: "/cms/menus", icon: FaListUl, text: "Menus" },
  { path: "/cms/chrome", icon: FaLayerGroup, text: "Headers & Footers" },
  { path: "/cms/settings", icon: FaCogs, text: "Site Settings" },
  { path: "/crm", icon: FaHandshake, text: "CRM Dashboard" },
  { path: "/crm/leads", icon: FaListUl, text: "Lead Management" },
  { path: "/crm/events", icon: FaCalendarCheck, text: "Events Log" },
  { path: "/crm/calls", icon: FaPhoneAlt, text: "Call Log" },
  { path: "/organizer", icon: FaTasks, text: "Office Dashboard" },
  { path: "/organizer/tasks", icon: FaTasks, text: "Task Management" },
  { path: "/organizer/projects", icon: FaProjectDiagram, text: "Project Management" },
  { path: "/organizer/documents", icon: FaEnvelopeOpenText, text: "Received Documents" },
  { path: "/organizer/emails", icon: FaEnvelope, text: "Emails" },
  { path: "/system/memory-monitoring", icon: FaServer, text: "Memory Monitoring" },
  { path: "/assistant", icon: FaRobot, text: "AI Assistant" },
  { path: "/assistant/settings", icon: FaCogs, text: "AI Assistant Settings" },
  { path: "/mobile/logistics", icon: FaMobileAlt, text: "Mobile Logistics Dashboard" },
  { path: "/mobile/routes", icon: FaRoute, text: "Mobile Route Management" },
  { path: "/mobile/deliveries", icon: FaBox, text: "Mobile Deliveries" },
  { path: "/mobile/tracking", icon: FaMapMarkerAlt, text: "Mobile GPS Tracking" },
  { path: "/mobile/inspection", icon: FaClipboard, text: "Mobile Vehicle Inspection" },
  { path: "/mobile/orders", icon: FaRegListAlt, text: "Mobile Orders" },
  { path: "/mobile/settings", icon: FaCogs, text: "Mobile Settings" },
  { path: "/cashmanagement/accounts", icon: FaUniversity, text: "Bank Accounts" },
  { path: "/cashmanagement/transactions", icon: FaMoneyBillWave, text: "Transactions" },
  { path: "/cashmanagement/customer-statement", icon: FaUsers, text: "Customer Statement" },
  { path: "/cashmanagement/supplier-statement", icon: FaTruck, text: "Supplier Statement" },
  { path: "/cashmanagement/scheduled-payments", icon: FaCalendarAlt, text: "Scheduled Payments" },
  { path: "/cashmanagement/opening-balances", icon: FaBalanceScale, text: "Opening Balances" },
  { path: "/cashmanagement/reconciliation", icon: FaBalanceScale, text: "Bank Reconciliation" },
  { path: "/cashmanagement/reports", icon: FaChartLine, text: "Cash Flow Reports" },
  { path: "/cashmanagement/transfers", icon: FaExchangeAlt, text: "Transfers" },
  { path: "/cashmanagement/receipts/customer", icon: FaReceipt, text: "Customer Receipt" },
  { path: "/cashmanagement/payments/supplier", icon: FaMoneyBillWave, text: "Supplier Payment" },
  { path: "/cashmanagement/payments/employee", icon: FaUserTie, text: "Employee Payment" },
  { path: "/cashmanagement/loans", icon: FaFileContract, text: "Loans" },
  { path: "/cashmanagement/settings", icon: FaCogs, text: "Cash Settings" },
  { path: "/accounting/chart-of-accounts", icon: FaSitemap, text: "Chart of Accounts" },
  { path: "/accounting/account-balances", icon: FaCalculator, text: "Account Balances" },
  { path: "/accounting/journal-entries", icon: FaBook, text: "Journal Entries" },
  { path: "/accounting/fiscal-periods", icon: FaCalendarAlt, text: "Fiscal Periods" },
  { path: "/accounting/reports", icon: FaChartLine, text: "Financial Reports" },
  { path: "/accounting/general-ledger", icon: FaBook, text: "General Ledger" },
  { path: "/accounting/fixed-assets", icon: FaBuilding, text: "Fixed Assets" },
  { path: "/accounting/settings", icon: FaCogs, text: "Accounting Settings" },
  { path: "/payroll", icon: FaUserTie, text: "Payroll Dashboard" },
  { path: "/payroll/employees", icon: FaUsers, text: "Employees" },
  { path: "/payroll/pay-periods", icon: FaCalendarAlt, text: "Pay Periods" },
  { path: "/payroll/entries", icon: FaPoundSign, text: "Payroll Entries" },
  { path: "/payroll/scenarios", icon: FaCog, text: "Pay Scenarios" },
  { path: "/payroll/timesheets", icon: FaClock, text: "Timesheets" },
  { path: "/payroll/schedules", icon: FaCalendarAlt, text: "Payroll Schedules" },
  { path: "/sales-targets", icon: FaBullseye, text: "Sales Targets" },
  { path: "/sales-targets/remuneration-rules", icon: FaPercentage, text: "Remuneration Rules" },
  { path: "/sales-targets/penalization-rules", icon: FaExclamationTriangle, text: "Penalization Rules" },
  { path: "/sales-targets/calculations", icon: FaCalculator, text: "Calculations" },
  { path: "/payment-terms", icon: FaFileContract, text: "Payment Terms" },
  { path: "/customer-segmentation-settings", icon: FaLayerGroup, text: "Customer Segmentation" },
  { path: "/catalogue-generator", icon: FaFilePdf, text: "Catalogue Generator" },
  { path: "/news", icon: FaRegNewspaper, text: "News" },
  { path: "/analytics", icon: FaChartBar, text: "Analytics Hub" },
  { path: "/analytics/sales", icon: FaChartBar, text: "Sales Reports" },
  { path: "/analytics/purchases", icon: FaChartBar, text: "Purchases Reports" },
  { path: "/analytics/production", icon: FaChartBar, text: "Production Reports" },
  { path: "/analytics/warehousing", icon: FaChartBar, text: "Warehousing Reports" },
  { path: "/analytics/logistics", icon: FaChartBar, text: "Logistics Reports" },
  { path: "/analytics/cash-management", icon: FaChartBar, text: "Cash Management Reports" },
  { path: "/analytics/payroll", icon: FaChartBar, text: "Payroll Reports" },
  { path: "/alerts", icon: FaBell, text: "System Alerts" },
  { path: "/help-centre", icon: FaQuestionCircle, text: "Help Centre" },
];

// Icon mapping for routes
export const routeIcons = {
  "/dashboard": FaTachometerAlt,
  "/": FaShoppingCart,
  "/products/admin": FaBoxes,
  "/barcodes": FaBarcode,
  "/prices": FaTag,
  "/discounts": FaPercentage,
  "/banners": FaImage,
  "/cart": FaShoppingCart,
  "/checkout": FaCartPlus,
  "/orders": FaRegListAlt,
  "/carts-management": FaShoppingCart,
  "/invoices": FaFileInvoice,
  "/credit-notes": FaUndo,
  "/map": FaMapMarkedAlt,
  "/customers": FaUsers,
  "/users": FaUsersCog,
  "/profile": FaUser,
  "/settings": FaCogs,
  "/system-logs": FaClipboardList,
  "/permissions-dashboard": FaChartLine,
  "/permission-control": FaShieldAlt,
  "/header-config": FaLayerGroup,
  "/sidebar-config": FaLayerGroup,
  "/customer-manager-assignments": FaCartPlus,
  "/sales-assignments": FaUserTag,
  "/customer-permissions": FaUserShield,
  "/customer-assignments": FaUsersCog,
  "/fulfillment": FaRoute,
  "/logistics": FaTruck,
  "/logistics/routes": FaRoute,
  "/logistics/drivers": FaUsersCog,
  "/logistics/tracking": FaMapMarkerAlt,
  "/logistics/deliveries": FaBox,
  "/logistics/vehicles": FaTruck,
  "/logistics/route-planner": FaRoute,
  "/logistics/locations": FaMapMarkerAlt,
  "/logistics/delivery-zones": FaGlobe,
  "/logistics/zone-neighbors": FaRoute,
  "/warehouses": FaWarehouse,
  "/purchase-order": FaFileInvoiceDollar,
  "/purchase-planner": FaCalculator,
  "/suppliers": FaTruck,
  "/purchase-invoices": FaFileImport,
  "/debit-notes": FaExchangeAlt,
  "/website-scraper": FaSpider,
  "/scraped-products": FaDownload,
  "/receipt": FaReceipt,
  "/picking": FaClipboardList,
  "/packing": FaBox,
  "/warehousing/inventory": FaBoxes,
  "/warehousing/stocktake": FaClipboardCheck,
  "/warehousing/transfers": FaTruck,
  "/production/dashboard": FaIndustry,
  "/production/planner": FaCalculator,
  "/production/weekly-plan": FaCalendarAlt,
  "/production/bom": FaProjectDiagram,
  "/production/orders": FaHammer,
  "/production/workcentres": FaCog,
  "/production/planning": FaCalendarAlt,
  "/production/wip-v2": FaTasks,
  "/production/station": FaHammer,
  "/production/workstation": FaHammer,
  "/production/releases": FaFileInvoice,
  "/production/qr-scanner": FaShieldAlt,
  "/production/reports": FaChartBar,
  "/production/operations": FaCog,
  "/production/skills": FaUserTag,
  "/cms/pages": FaGlobe,
  "/cms/posts": FaRegNewspaper,
  "/cms/menus": FaListUl,
  "/cms/chrome": FaLayerGroup,
  "/cms/settings": FaCogs,
  "/crm": FaHandshake,
  "/crm/leads": FaListUl,
  "/crm/events": FaCalendarCheck,
  "/crm/calls": FaPhoneAlt,
  "/organizer": FaTasks,
  "/organizer/dashboard": FaTasks,
  "/organizer/tasks": FaTasks,
  "/organizer/projects": FaProjectDiagram,
  "/organizer/documents": FaEnvelopeOpenText,
  "/organizer/emails": FaEnvelope,
  "/system/memory-monitoring": FaServer,
  "/assistant": FaRobot,
  "/assistant/settings": FaCogs,
  "/cashmanagement/accounts": FaUniversity,
  "/cashmanagement/transactions": FaMoneyBillWave,
  "/cashmanagement/customer-statement": FaUsers,
  "/cashmanagement/supplier-statement": FaTruck,
  "/cashmanagement/scheduled-payments": FaCalendarAlt,
  "/cashmanagement/opening-balances": FaBalanceScale,
  "/cashmanagement/reconciliation": FaBalanceScale,
  "/cashmanagement/reports": FaChartLine,
  "/cashmanagement/transfers": FaExchangeAlt,
  "/cashmanagement/loans": FaFileContract,
  "/cashmanagement/settings": FaCogs,
  "/accounting/chart-of-accounts": FaSitemap,
  "/accounting/account-balances": FaCalculator,
  "/accounting/journal-entries": FaBook,
  "/accounting/fiscal-periods": FaCalendarAlt,
  "/accounting/reports": FaChartLine,
  "/accounting/general-ledger": FaBook,
  "/accounting/fixed-assets": FaBuilding,
  "/accounting/settings": FaCogs,
  "/payroll": FaUserTie,
  "/payroll/employees": FaUsers,
  "/payroll/pay-periods": FaCalendarAlt,
  "/payroll/entries": FaPoundSign,
  "/payroll/scenarios": FaCog,
  "/payroll/timesheets": FaClock,
  "/payroll/schedules": FaCalendarAlt,
  "/sales-targets": FaBullseye,
  "/sales-targets/remuneration-rules": FaPercentage,
  "/sales-targets/penalization-rules": FaExclamationTriangle,
  "/sales-targets/calculations": FaCalculator,
  "/payment-terms": FaFileContract,
  "/customer-segmentation-settings": FaLayerGroup,
  "/catalogue-generator": FaFilePdf,
  "/news": FaRegNewspaper,
  "/analytics": FaChartBar,
  "/analytics/sales": FaChartBar,
  "/analytics/purchases": FaChartBar,
  "/analytics/production": FaChartBar,
  "/analytics/warehousing": FaChartBar,
  "/analytics/logistics": FaChartBar,
  "/analytics/cash-management": FaChartBar,
  "/analytics/payroll": FaChartBar,
  "/alerts": FaBell,
  "/help-centre": FaQuestionCircle,
};

// Text mapping for routes
export const routeLabels = {
  "/dashboard": "Dashboard",
  "/": "Product Catalog",
  "/products/admin": "Products Admin",
  "/barcodes": "Barcodes",
  "/prices": "Price Management",
  "/discounts": "Discounts",
  "/banners": "Banners",
  "/cart": "Shopping Cart",
  "/checkout": "Checkout",
  "/orders": "Orders",
  "/carts-management": "Carts Management",
  "/invoices": "Invoices",
  "/credit-notes": "Credit Notes",
  "/map": "Map",
  "/customers": "Customers",
  "/users": "User Management",
  "/profile": "My Account",
  "/settings": "System Settings",
  "/system-logs": "System Logs",
  "/permissions-dashboard": "Permissions Dashboard",
  "/permission-control": "Permission Control",
  "/header-config": "Header Configuration",
  "/sidebar-config": "Sidebar Configuration",
  "/customer-manager-assignments": "Shop Assignment",
  "/sales-assignments": "Sales Assignments",
  "/customer-permissions": "Customer Permissions",
  "/customer-assignments": "Customer Assignments",
  "/fulfillment": "Orders Fulfillment",
  "/logistics": "Logistics",
  "/logistics/routes": "Routes",
  "/logistics/drivers": "Drivers",
  "/logistics/tracking": "Live Tracking",
  "/logistics/deliveries": "Deliveries",
  "/logistics/vehicles": "Vehicles",
  "/logistics/route-planner": "Route Planner",
  "/logistics/locations": "Location Management",
  "/logistics/delivery-zones": "Delivery Zones",
  "/logistics/zone-neighbors": "Zone Neighbors",
  "/warehouses": "Warehouses",
  "/purchase-order": "Purchase Orders",
  "/purchase-planner": "Purchase Planner",
  "/suppliers": "Suppliers",
  "/purchase-invoices": "Purchase Invoices",
  "/debit-notes": "Debit Notes",
  "/website-scraper": "Website Scraper",
  "/scraped-products": "Suppliers Products",
  "/receipt": "Receipt",
  "/picking": "Picking",
  "/packing": "Packing",
  "/warehousing/inventory": "Inventory Management",
  "/warehousing/stocktake": "Stocktake",
  "/warehousing/transfers": "Warehouse Transfers",
  "/production/dashboard": "Production Dashboard",
  "/production/planner": "Production Planner",
  "/production/weekly-plan": "Weekly Production Plan",
  "/production/bom": "BOM Management",
  "/production/orders": "Production Orders",
  "/production/workcentres": "Work Centres",
  "/production/planning": "Production Planning",
  "/production/wip-v2": "WIP Tracking V2",
  "/production/station": "Operator Station",
  "/production/workstation": "Workstation",
  "/production/releases": "Production Releases",
  "/production/qr-scanner": "QR Scanner",
  "/production/reports": "Production Reports",
  "/production/operations": "Operations Management",
  "/production/skills": "Skills",
  "/cms/pages": "Pages",
  "/cms/posts": "Posts",
  "/cms/menus": "Menus",
  "/cms/chrome": "Headers & Footers",
  "/cms/settings": "Site Settings",
  "/crm": "CRM Dashboard",
  "/crm/leads": "Lead Management",
  "/crm/events": "Events Log",
  "/crm/calls": "Call Log",
  "/organizer": "Office Dashboard",
  "/organizer/dashboard": "Office Dashboard",
  "/organizer/tasks": "Task Management",
  "/organizer/projects": "Project Management",
  "/organizer/documents": "Received Documents",
  "/organizer/emails": "Emails",
  "/system/memory-monitoring": "Memory Monitoring",
  "/assistant": "AI Assistant",
  "/assistant/settings": "AI Assistant Settings",
  "/mobile/logistics": "Mobile Logistics Dashboard",
  "/mobile/routes": "Mobile Route Management",
  "/mobile/deliveries": "Mobile Deliveries",
  "/mobile/tracking": "Mobile GPS Tracking",
  "/mobile/inspection": "Mobile Vehicle Inspection",
  "/mobile/orders": "Mobile Orders",
  "/mobile/settings": "Mobile Settings",
  "/cashmanagement/accounts": "Bank Accounts",
  "/cashmanagement/transactions": "Transactions",
  "/cashmanagement/customer-statement": "Customer Statement",
  "/cashmanagement/supplier-statement": "Supplier Statement",
  "/cashmanagement/scheduled-payments": "Scheduled Payments",
  "/cashmanagement/opening-balances": "Opening Balances",
  "/cashmanagement/reconciliation": "Bank Reconciliation",
  "/cashmanagement/reports": "Cash Flow Reports",
  "/cashmanagement/transfers": "Transfers",
  "/cashmanagement/loans": "Loans",
  "/cashmanagement/settings": "Cash Settings",
  "/accounting/chart-of-accounts": "Chart of Accounts",
  "/accounting/account-balances": "Account Balances",
  "/accounting/journal-entries": "Journal Entries",
  "/accounting/fiscal-periods": "Fiscal Periods",
  "/accounting/reports": "Financial Reports",
  "/accounting/general-ledger": "General Ledger",
  "/accounting/fixed-assets": "Fixed Assets",
  "/accounting/settings": "Accounting Settings",
  "/payroll": "Payroll Dashboard",
  "/payroll/employees": "Employees",
  "/payroll/pay-periods": "Pay Periods",
  "/payroll/entries": "Payroll Entries",
  "/payroll/scenarios": "Pay Scenarios",
  "/payroll/timesheets": "Timesheets",
  "/payroll/schedules": "Payroll Schedules",
  "/sales-targets": "Sales Targets",
  "/sales-targets/remuneration-rules": "Remuneration Rules",
  "/sales-targets/penalization-rules": "Penalization Rules",
  "/sales-targets/calculations": "Calculations",
  "/payment-terms": "Payment Terms",
  "/customer-segmentation-settings": "Customer Segmentation",
  "/catalogue-generator": "Catalogue Generator",
  "/news": "News",
  "/analytics": "Analytics Hub",
  "/analytics/sales": "Sales Reports",
  "/analytics/purchases": "Purchases Reports",
  "/analytics/production": "Production Reports",
  "/analytics/warehousing": "Warehousing Reports",
  "/analytics/logistics": "Logistics Reports",
  "/analytics/cash-management": "Cash Management Reports",
  "/analytics/payroll": "Payroll Reports",
  "/alerts": "System Alerts",
  "/help-centre": "Help Centre",
};
export const routeIconForPath = (path) => {
  if (routeIcons[path]) return routeIcons[path];
  const prefix = Object.keys(routeIcons)
    .filter((p) => p !== '/' && path.startsWith(`${p}/`))
    .sort((a, b) => b.length - a.length)[0];
  return prefix ? routeIcons[prefix] : undefined;
};

export const DEFAULT_MOBILE_NAV_ROUTES = ['/products', '/cart', '/checkout', '/dashboard'];
export const MAX_MOBILE_NAV_ROUTES = 5;

export const resolveMobileNavRoutes = (configured) => (
  Array.isArray(configured) && configured.length > 0 ? configured : DEFAULT_MOBILE_NAV_ROUTES
);

export const mobileNavOptions = () => Object.entries(routeLabels)
  .map(([path, label]) => (path === '/' ? ['/products', 'Home'] : [path, label]))
  .sort(([, a], [, b]) => a.localeCompare(b));

export const usesCustomSidebar = (configuration) => (
  (configuration?.categories?.length || 0) > 0 || (configuration?.hidden_routes?.length || 0) > 0
);
